module.exports = __webpack_public_path__ + "img/lookbook_10_left.1f04c04d.png";